import React from "react";
import Grid from "onnit-ui/lib/module/grid/12/Grid";
import Box from "onnit-ui/lib/box/Box";
import ingredientsFlowBlend from "./ingredients-flow-blend";
import ingredientsFocusBlend from "./ingredients-focus-blend";
import ingredientsFuelBlend from "./ingredients-fuel-blend";
import MediaContentShowcase from "onnit-ui/lib/module/MediaContentShowcase";
import { Img } from "onnit-ui/lib/image";
import Text, { Sup } from "onnit-ui/lib/text";

export default function ({ imageUrl }: { imageUrl: string }) {
    const AB_IMG_URL = imageUrl;

    return (
        <Box bg="black" py={[6, 6, 6, 8]}>
            <Box>
                <Grid mb={4}>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / -1", "2 / span 12"]} pt={3} px={[4, 4, 4, 0]}>
                        <Text role="heading" aria-level={2} as="p" typeStyle="copyDisplay02" color="white">
                            Onnit Flow Blend
                            <Sup variant="trade" /> and Cat&rsquo;s Claw
                        </Text>
                    </Box>
                </Grid>

                <MediaContentShowcase
                    mb={[6]}
                    items={ingredientsFlowBlend.map((x) => {
                        let copy = { ...x };
                        copy.image = `${AB_IMG_URL}/${x.image}`;
                        return copy;
                    })}
                    textColor="white"
                    activeColor="#F05F3B"
                    bgMedia={
                        <Img
                            placeholder={[754, 208]}
                            src={`${AB_IMG_URL}/bg--river.jpg?q=75&auto=format`}
                            alt="River background for Flow Blend"
                        />
                    }
                />

                <Grid>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / -1", "3 / span 9"]} pt={3} px={[4, 4, 4, 0]}>
                        <Text as="p" typeStyle="copyHero02" color="white" mb={[6, 6, 8]}>
                            Target: Promote alpha brain wave production.
                            <Sup variant="dagger" />
                        </Text>
                        <Text as="p" typeStyle="copyHero02" color="white" mb={[6, 6, 8]}>
                            Being in a flow state is associated with greater activity of alpha brain waves. Research
                            actually shows that the brain is better organized and more calm and focused when alpha waves
                            are firing high. The Onnit Flow Blend
                            <Sup variant="trade" /> provides amino acids and other plant compounds that promote alpha
                            brain wave production and optimal brain cell function.
                            <Sup variant="dagger" />
                        </Text>

                        <Text as="p" typeStyle="copyHero02" color="white" mb={[6, 6, 8]}>
                            This formula is further supported by Cat&rsquo;s Claw extract, which comes from the bark of
                            an Amazon rainforest vine. Cat&rsquo;s Claw is known to promote cellular integrity.
                            <Sup variant="dagger" />
                        </Text>
                    </Box>
                </Grid>
            </Box>

            <Box>
                <Grid mb={4}>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / -1", "2 / span 12"]} pt={3} px={[4, 4, 4, 0]}>
                        <Text role="heading" aria-level={2} as="p" typeStyle="copyDisplay02" color="white">
                            Onnit Focus Blend
                            <Sup variant="trade" />
                        </Text>
                    </Box>
                </Grid>

                <MediaContentShowcase
                    mb={[6]}
                    items={ingredientsFocusBlend.map((x) => {
                        let copy = { ...x };
                        copy.image = `${AB_IMG_URL}/${x.image}`;
                        return copy;
                    })}
                    textColor="white"
                    activeColor="#F05F3B"
                    bgMedia={
                        <Img
                            placeholder={[754, 208]}
                            src={`${AB_IMG_URL}/bg--mountains.jpg?q=75&auto=format`}
                            alt="Mountains background for Focus Blend"
                        />
                    }
                />

                <Grid>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / -1", "3 / span 9"]} pt={3} px={[4, 4, 4, 0]}>
                        <Text as="p" typeStyle="copyHero02" color="white" mb={[6, 6, 8]}>
                            Target: Optimal acetylcholine levels.
                            <Sup variant="dagger" />
                        </Text>
                        <Text as="p" typeStyle="copyHero02" color="white" mb={[6, 6, 8]}>
                            Acetylcholine is one of the body&rsquo;s most important neurotransmitters, as it controls
                            nerves, muscle cells, and hormonal glands. The compounds in the Onnit Focus Blend{" "}
                            <Sup variant="trade" />
                            help the body make acetylcholine, sustain optimal levels, and encourage nerve cells to
                            receive it. This formula gains additional support from vitamin B6, which has been shown to
                            play an important role in neurotransmitter production.
                            <Sup variant="dagger" />
                        </Text>
                    </Box>
                </Grid>
            </Box>

            <Box>
                <Grid mb={4}>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / -1", "2 / span 12"]} pt={3} px={[4, 4, 4, 0]}>
                        <Text role="heading" aria-level={2} as="p" typeStyle="copyDisplay02" color="white">
                            Onnit Fuel Blend
                            <Sup variant="trade" />
                        </Text>
                    </Box>
                </Grid>

                <MediaContentShowcase
                    mb={[6]}
                    items={ingredientsFuelBlend.map((x) => {
                        let copy = { ...x };
                        copy.image = `${AB_IMG_URL}/${x.image}`;
                        return copy;
                    })}
                    textColor="white"
                    activeColor="#F05F3B"
                    bgMedia={
                        <Img
                            placeholder={[754, 208]}
                            src={`${AB_IMG_URL}/bg--plants.jpg?q=75&auto=format`}
                            alt="Plants Background"
                        />
                    }
                />

                <Grid>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / -1", "3 / span 9"]} pt={3} px={[4, 4, 4, 0]}>
                        <Text as="p" typeStyle="copyHero02" color="white" mb={[6, 6, 8]}>
                            Target: Optimal nervous system communication.
                            <Sup variant="dagger" />
                        </Text>
                        <Text as="p" typeStyle="copyHero02" color="white" mt={6} mb={[6, 6, 8]}>
                            To top it all off, the Onnit Fuel Blend
                            <Sup variant="trade" /> has been formulated with the goal of maintaining a healthy brain
                            environment, further optimizing neural communication.
                        </Text>
                    </Box>
                </Grid>
            </Box>
        </Box>
    );
}
